<script setup lang="ts">
const props = defineProps<{
  direction: 'top' | 'bottom'
  isLoading: boolean
  disabled: boolean
}>()

defineEmits<{
  click: []
}>()

const labels = computed(() => {
  if (props.direction === 'top') {
    return {
      loading: 'Laster...',
      default: 'Last inn tidligere sider',
    }
  }
  return {
    loading: 'Laster...',
    default: 'Last inn flere sider',
  }
})

const buttonClass = computed(() => {
  const base = 'px-4 py-2 text-sm font-medium rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:bg-surface-primary dark:text-white dark:hover:bg-surface-hover'
  if (props.direction === 'top') {
    return `${base} text-blue-600 bg-blue-50 hover:bg-blue-100`
  }
  return `${base} text-blurple-500 bg-blurple-100 hover:bg-blue-100`
})
</script>

<template>
  <div class="flex justify-center py-4">
    <button
      type="button"
      :class="buttonClass"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <span v-if="isLoading">{{ labels.loading }}</span>
      <span v-else>{{ labels.default }}</span>
    </button>
  </div>
</template>
